import { Col, Form, Input, Modal, Row, Select } from 'antd';
import React from 'react';
import { useCreateFood } from '../api/hooks';
import { useNotifixationStore } from '../stores/notification';
import styled from 'styled-components';

type AddFoodProps = {
  open: boolean;
  onClose: () => void;
};

function AddFood({ open, onClose }: AddFoodProps) {
  const [type, setType] = React.useState('Lamb');
  const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = React.useState('');

  const onUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImageUrl(e.target.value);
    form.setFieldValue('imageUrl', e.target.value);
  };

  const notification = useNotifixationStore();

  const mutation = useCreateFood({
    onSuccess: () => {
      notification.addNotification({
        id: Math.random().toString(),
        message: 'Success!',
        code: 200,
        description: 'Thanks for your contribution!',
        type: 'success',
      });
      onClose();
    },
    onError: (error) => {
      notification.addNotification({
        id: Math.random().toString(),
        message: 'Error!',
        code: error.response?.status,
        description: error.message,
        type: 'error',
      });
    },
  });

  const addFood = async (values: any) => {
    mutation.mutate(values);
  };

  const onOk = () => {
    form.submit();
  };

  return (
    <Modal
      open={open}
      title='Add a new food'
      okText='Add'
      cancelText='Cancel'
      onCancel={onClose}
      onOk={onOk}
      confirmLoading={mutation.isLoading}
    >
      <Form
        layout='vertical'
        name='form_in_modal'
        form={form}
        onFinish={addFood}
      >
        <Form.Item
          name='name'
          label='Name'
          rules={[
            {
              required: true,
              message: 'Please input the food name!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='imageUrl'
          label='Image URL'
          rules={[
            {
              required: true,
              message: 'Please add a nice photo!!',
            },
          ]}
        >
          <Input onChange={onUrlChange} />
        </Form.Item>
        <Row>
          <Col span={10}>
            <Form.Item name='type' label='Category' initialValue={type}>
              <Select
                style={{ width: 120 }}
                onChange={setType}
                options={[
                  { value: 'Lamb', label: 'Lamb' },
                  { value: 'Beef', label: 'Beef' },
                  { value: 'Fish', label: 'Fish' },
                  { value: 'Pork', label: 'Pork' },
                  { value: 'Chicken', label: 'Chicken' },
                  { value: 'Vegetarian', label: 'Vegetarian' },
                  { value: 'Pasta', label: 'Pasta' },
                  { value: 'Turkey', label: 'Turkey' },
                  { value: 'Other', label: 'Other' },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={4} offset={10}>
            {imageUrl && <ImagePreview src={imageUrl} alt='image preview' />}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddFood;

const ImagePreview = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
`;
